var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimelineCalendar = function SvgTimelineCalendar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 28.8001H25.5999V6.21191H6.3999V28.8001Z",
    fill: "#FFC8B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 12.2355H25.5999V5.45898H6.3999V12.2355Z",
    fill: "#FF9265"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01807 9.97667H12.509V3.2002H9.01807V9.97667Z",
    fill: "#FFC8B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4907 9.97667H22.9816V3.2002H19.4907V9.97667Z",
    fill: "#FFC8B2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimelineCalendar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjM5OTkgMjguODAwMUgyNS41OTk5VjYuMjExOTFINi4zOTk5VjI4LjgwMDFaIiBmaWxsPSIjRkZDOEIyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi4zOTk5IDEyLjIzNTVIMjUuNTk5OVY1LjQ1ODk4SDYuMzk5OVYxMi4yMzU1WiIgZmlsbD0iI0ZGOTI2NSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuMDE4MDcgOS45NzY2N0gxMi41MDlWMy4yMDAySDkuMDE4MDdWOS45NzY2N1oiIGZpbGw9IiNGRkM4QjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS40OTA3IDkuOTc2NjdIMjIuOTgxNlYzLjIwMDJIMTkuNDkwN1Y5Ljk3NjY3WiIgZmlsbD0iI0ZGQzhCMiIvPgo8L3N2Zz4K";